import { ScoreHealthRangeBreakpoint } from '../../..';

export const ESTATE_STATUS_SCORE_HEALTH_RANGE_BREAKPOINTS: ScoreHealthRangeBreakpoint[] = [
  { category: 'atypicallyLow', min: 0, max: 0.2, id: 'atypicallyLow_Es' },
  { category: 'low', min: 0.2, max: 0.4, id: 'low_Es' },
  { category: 'typical', min: 0.4, max: 0.8, id: 'typical_Es' },
  { category: 'high', min: 0.8, max: 0.9, id: 'high_Es' },
  { category: 'atypicallyHigh', min: 0.9, max: 1, id: 'atypicallyHigh_Es' },
];
